import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";

import { ChevronLeft, ChevronRight } from "lucide-react";
import FarmCardStyle from "../../assets/stylesheets/FarmCard.module.css";
import Logger from "../../utils/logger";

const log = Logger.create("TopEventsCarousel");
const blogsCarouselContainerTitle = "What We're Talking About";
const blogsCarouselContainerSubtitle = "From how-to's to hidden gems – find your next farm idea here";

export default function TopEventsCarousel() {
  const [blogPosts, setBlogPosts] = useState([]);
  const uniqueId = "blog";

  useEffect(() => {
    fetch('https://farmmode.ca/wp-json/wp/v2/posts?per_page=4&_embed')
      .then(res => res.json())
      .then(data => {
        const posts = data.map(post => ({
          title: post.title.rendered,
          link: post.link,
          image:
            post._embedded?.['wp:featuredmedia']?.[0]?.source_url ||
            'https://via.placeholder.com/400x300?text=No+Image',
        }));
        setBlogPosts(posts);
      })
      .catch(err => log.error('Error fetching blog posts:', err));
  }, []);

  return (
    <section className={FarmCardStyle['events-section']}>
      <div className={FarmCardStyle['events-container']}>
        <div className={FarmCardStyle['events-header']}>
          <div>
            <h2 className={FarmCardStyle['events-title']}>
              {blogsCarouselContainerTitle} &#62;
            </h2>
            <p className={FarmCardStyle['events-subtitle']}>
              {blogsCarouselContainerSubtitle}
            </p>
          </div>
          <div className={FarmCardStyle['event-card-arrow']}>
            <button
              className={`${FarmCardStyle['swiper-prev']} swiper-prev-${uniqueId}`}
            >
              <ChevronLeft className={FarmCardStyle['custom-arrow-icon']} />
            </button>
            <button
              className={`${FarmCardStyle['swiper-next']} swiper-next-${uniqueId}`}
            >
              <ChevronRight className={FarmCardStyle['custom-arrow-icon']} />
            </button>
          </div>
        </div>
        <div className={FarmCardStyle['events-carousel-wrapper']}>
          <Swiper
            modules={[FreeMode, Navigation]}
            freeMode={true}
            spaceBetween={10}
            slidesPerView={2.5}
            navigation={{
              prevEl: `.swiper-prev-${uniqueId}`,
              nextEl: `.swiper-next-${uniqueId}`,
            }}
            breakpoints={{
              0: { slidesPerView: 2 },
              480: { slidesPerView: 2 },
              768: { slidesPerView: 3 },
              1024: { slidesPerView: 4 },
            }}
            className={FarmCardStyle['swiper-carousel']}
          >
            {blogPosts.map((post, index) => (
              <SwiperSlide key={index}>
                <div className={FarmCardStyle['event-card']}>
                  <div className={FarmCardStyle['event-card-image-container']}>
                    <a
                      href={post.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={post.image}
                        alt={post.title}
                        className={FarmCardStyle['event-card-image']}
                      />
                    </a>
                  </div>
                  <h3 className={FarmCardStyle['event-card-title']}>
                    <span dangerouslySetInnerHTML={{ __html: post.title }} />
                  </h3>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}
